// extracted by mini-css-extract-plugin
module.exports = {"calloutTextBlock":"callout-text_calloutTextBlock__DWw6N","calloutTextTitle":"callout-text_calloutTextTitle__Y_OcY","calloutTextText":"callout-text_calloutTextText__0ZvXr"};